import script from "./PaymentFailure.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentFailure.vue?vue&type=script&setup=true&lang=js"

import "./PaymentFailure.vue?vue&type=style&index=0&id=20333a78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20333a78"]])

export default __exports__